// extracted by mini-css-extract-plugin
export default {"black_border_wrap":"invoiceShimmer_black_border_wrap__vVuox","gray_border_wrap":"invoiceShimmer_gray_border_wrap__2IcHF","auto_height_wrap":"invoiceShimmer_auto_height_wrap__cxwh-"};